export const BRAND_NAME = 'Brihha';
export const BRAND_SHORT_CODE = 'Brihha';
export const HELP_DESK = false;
export const TOPBAR_LOGO = false;
export const LOGIN_LOGO = false;
export const LOGIN_PAGEBEFORE = false;
export const LOGIN_PAGEAFTER = false;
export const COMMONERRORMESSAGE = "We encountered an unexpected error. Please try again. If the issue persists, contact the support team for assistance.";
